import i18n from "../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import FeatureBadgeRow, { TFeatureBadge } from "../feature-badge-row";
import {
  FEATURE_SET_TAG_WIDTH_LARGE,
  FEATURE_SET_TAG_WIDTH_MEDIUM
} from "../feature-badge-row/feature-tag-constants";

const ActiveFeaturesByFeatureSets = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const advancedStore = getUserAdvancedStore();
  const {
    isPaidSilver,
    isPaidGold,
    isPaidBlack,
    isPaidPlatinum,
    isPaidVIP,
    isPaidPower,
    isPaidBoost,
    isPaidRewind,
    isPaidPlus,
    isSubscribedBoost,
    isSubscribedRewind,
    isSubscribedVIP,
    isSubscribedSilver,
    isSubscribedGold,
    isSubscribedBlack,
    isSubscribedPlatinum,
    isSubscribedPower,
    isSubscribedPlus
  } = advancedStore.getUserSubscriptionStatus.get();

  const badges: TFeatureBadge[] = [
    {
      tag: i18n.get("BOOST"),
      tagColor:
        isSubscribedVIP ||
        isSubscribedGold ||
        isSubscribedBlack ||
        isSubscribedPlatinum ||
        isSubscribedPower ||
        isSubscribedBoost
          ? colors.all.vipGold
          : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_MEDIUM,
      isActive:
        isPaidVIP ||
        isPaidGold ||
        isPaidBlack ||
        isPaidPlatinum ||
        isPaidPower ||
        isPaidBoost
    },
    {
      tag: i18n.get("REWIND"),
      tagColor:
        isSubscribedSilver ||
        isSubscribedGold ||
        isSubscribedBlack ||
        isSubscribedPlatinum ||
        isSubscribedPower ||
        isSubscribedRewind
          ? colors.all.purple
          : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_MEDIUM,
      isActive:
        isPaidSilver ||
        isPaidGold ||
        isPaidBlack ||
        isPaidPlatinum ||
        isPaidPower ||
        isPaidRewind
    },
    {
      tag: i18n.get("READ"),
      tagColor:
        isSubscribedGold ||
        isSubscribedBlack ||
        isSubscribedPlatinum ||
        isSubscribedPower
          ? colors.all.powerPurple
          : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_MEDIUM,
      isActive: isPaidGold || isPaidBlack || isPaidPlatinum || isPaidPower
    },
    {
      tag: i18n.get("CONVERSATION_BADGE"),
      tagColor:
        isSubscribedGold || isSubscribedBlack || isSubscribedPlatinum
          ? colors.all.darkOrange
          : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_LARGE,
      isActive: isPaidGold || isPaidBlack || isPaidPlatinum
    },
    {
      tag: i18n.get("LIKES"),
      tagColor:
        isSubscribedSilver ||
        isSubscribedGold ||
        isSubscribedBlack ||
        isSubscribedPlatinum ||
        isSubscribedPlus
          ? colors.all.green
          : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_LARGE,
      isActive:
        isPaidSilver ||
        isPaidGold ||
        isPaidBlack ||
        isPaidPlatinum ||
        isPaidPlus
    }
  ];

  return <FeatureBadgeRow labelKey={"VIA_FEATURE_SETS"} badges={badges} />;
});

export default ActiveFeaturesByFeatureSets;
